import { render, staticRenderFns } from "./TeacherChatBubble.vue?vue&type=template&id=a3a2ea10&scoped=true"
import script from "./TeacherChatBubble.vue?vue&type=script&lang=ts"
export * from "./TeacherChatBubble.vue?vue&type=script&lang=ts"
import style0 from "./TeacherChatBubble.vue?vue&type=style&index=0&id=a3a2ea10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a2ea10",
  null
  
)

export default component.exports
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QChatMessage,QSpinnerDots,QBtn});
